@if (platformModeService.isNativeApp()) {
  <ion-header [translucent]="true">
    <ion-toolbar class="bw-app-shell-toolbar">
      <div class="bw-app-shell__toolbar bw-app-shell__toolbar--native">
        <div class="bw-app-shell__brand-row">
          <button
            type="button"
            class="bw-app-shell__menu-button"
            aria-label="Toggle navigation"
            (click)="toggleSidebar()"
          >
            <ion-icon name="menu-outline"></ion-icon>
          </button>
          <a class="bw-app-shell__brand" routerLink="/">
            <img src="assets/logo/bee.png" alt="BizzWeaver" class="bw-app-shell__brand-logo" />
            <span class="bw-app-shell__brand-name">BizzWeaver</span>
          </a>
        </div>
        <div class="bw-app-shell__toolbar-title" [title]="currentConfig.title">
          @if (currentConfig.translateTitle) {
            <span>{{ currentConfig.title | translate }}</span>
          } @else {
            <span>{{ currentConfig.title }}</span>
          }
        </div>
        @if (currentConfig.showUserMenu) {
          <div class="bw-app-shell__toolbar-end">
            @if (currentConfig.showUserMenu) {
              <app-user-menu
                [userName]="currentUser?.name || null"
                [userNickname]="currentUser?.nickname || null"
                [userEmail]="currentUser?.email || null"
              ></app-user-menu>
            }
          </div>
        }
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content [fullscreen]="true" [scrollY]="!isAiChatRoute">
    <div class="bw-app-shell bw-app-shell--native" [class.bw-app-shell--ai-chat]="isAiChatRoute">
      <app-sidebar
        class="bw-app-shell__sidebar-host"
        [collapsed]="false"
        [hidden]="false"
        [pinnedExpanded]="true"
        [compact]="true"
        [open]="mobileSidebarOpen"
        [userRole]="currentUser?.platformRole ?? null"
        (closeRequest)="closeMobileSidebar()"
      ></app-sidebar>

      <div class="bw-app-shell__body bw-app-shell__body--compact"
        [class.bw-app-shell__body--ai-chat]="isAiChatRoute"
        [class.bw-app-shell__body--with-assistant-side]="!isAiChatRoute && assistantLayout.isOpen && assistantLayout.displayMode === 'side' && !isCompactMode"
        [class.bw-app-shell__body--with-assistant-bottom]="!isAiChatRoute && assistantLayout.isOpen && assistantLayout.displayMode === 'bottom' && !isCompactMode"
        [style.--bw-assistant-side-width]="assistantSideWidthCss"
        [style.--bw-assistant-bottom-height]="assistantBottomHeightCss">
        <main class="bw-app-shell__main">
          <div class="bw-app-shell__page" [class.bw-app-shell__page--full-width]="currentConfig.fullWidth">
            <router-outlet></router-outlet>
          </div>
        </main>
      </div>

      @if (routeHasRightPanel) {
        <div class="bw-app-shell__right-panel-host" [class.bw-app-shell__right-panel-host--overlay]="isCompactMode">
          <app-right-panel
            [config]="currentConfig.rightPanel ?? null"
            [compact]="isCompactMode"
            [open]="showRightPanel"
            (toggleRequest)="toggleRightPanel()"
            (closeRequest)="closeRightPanel()"
          ></app-right-panel>
        </div>
      }

      @if (!isAiChatRoute) {
        @if (assistantLayout.isOpen && assistantLayout.displayMode === 'side' && !isCompactMode) {
          <div
            class="bw-app-shell__assistant-resizer bw-app-shell__assistant-resizer--side"
            role="separator"
            tabindex="0"
            aria-label="Resize BizzWeaver AI side panel"
            aria-orientation="vertical"
            [attr.aria-valuemin]="352"
            [attr.aria-valuemax]="assistantSideWidthMaximum"
            [attr.aria-valuenow]="assistantLayout.sidePanelWidth"
            (pointerdown)="beginAssistantResize($event, 'side')"
            (keydown)="resizeAssistantWithKeyboard($event, 'side')"
          ></div>
        }
        @if (assistantLayout.isOpen && assistantLayout.displayMode === 'bottom' && !isCompactMode) {
          <div
            class="bw-app-shell__assistant-resizer bw-app-shell__assistant-resizer--bottom"
            role="separator"
            tabindex="0"
            aria-label="Resize BizzWeaver AI bottom panel"
            aria-orientation="horizontal"
            [attr.aria-valuemin]="240"
            [attr.aria-valuemax]="assistantBottomHeightMaximum"
            [attr.aria-valuenow]="assistantLayout.bottomPanelHeight"
            (pointerdown)="beginAssistantResize($event, 'bottom')"
            (keydown)="resizeAssistantWithKeyboard($event, 'bottom')"
          ></div>
        }
        <app-ai-assistant
          class="bw-app-shell__assistant-host"
          [class.bw-app-shell__assistant-host--side]="assistantLayout.isOpen && assistantLayout.displayMode === 'side' && !isCompactMode"
          [class.bw-app-shell__assistant-host--bottom]="assistantLayout.isOpen && assistantLayout.displayMode === 'bottom' && !isCompactMode"
          [class.bw-app-shell__assistant-host--floating]="!assistantLayout.isOpen || assistantLayout.displayMode === 'floating' || isCompactMode"
          [user]="currentUser"
        ></app-ai-assistant>
      }
    </div>
  </ion-content>
} @else {
  <div class="bw-app-shell" [class.bw-app-shell--ai-chat]="isAiChatRoute">
    <header class="bw-app-shell__header">
      <div class="bw-app-shell__toolbar">
        <div class="bw-app-shell__brand-row">
          <button
            type="button"
            class="bw-app-shell__menu-button"
            aria-label="Toggle navigation"
            (click)="toggleSidebar()"
          >
            <ion-icon name="menu-outline"></ion-icon>
          </button>
          <a class="bw-app-shell__brand" routerLink="/">
            <img src="assets/logo/bee.png" alt="BizzWeaver" class="bw-app-shell__brand-logo" />
            <span class="bw-app-shell__brand-name">BizzWeaver</span>
          </a>
        </div>
        <div class="bw-app-shell__toolbar-title" [title]="currentConfig.title">
          @if (currentConfig.translateTitle) {
            <span>{{ currentConfig.title | translate }}</span>
          } @else {
            <span>{{ currentConfig.title }}</span>
          }
        </div>
        @if (currentConfig.showUserMenu) {
          <div class="bw-app-shell__toolbar-end">
            @if (currentConfig.showUserMenu) {
              <app-user-menu
                [userName]="currentUser?.name || null"
                [userNickname]="currentUser?.nickname || null"
                [userEmail]="currentUser?.email || null"
              ></app-user-menu>
            }
          </div>
        }
      </div>
    </header>

    <div
      class="bw-app-shell__body"
      [class.bw-app-shell__body--compact]="platformModeService.isCompactViewport()"
      [class.bw-app-shell__body--sidebar-hidden]="!desktopSidebarVisible && !isCompactMode"
      [class.bw-app-shell__body--with-right-panel]="routeHasRightPanel && !isCompactMode"
      [class.bw-app-shell__body--with-assistant-side]="!isAiChatRoute && assistantLayout.isOpen && assistantLayout.displayMode === 'side' && !isCompactMode"
      [class.bw-app-shell__body--with-assistant-bottom]="!isAiChatRoute && assistantLayout.isOpen && assistantLayout.displayMode === 'bottom' && !isCompactMode"
      [class.bw-app-shell__body--ai-chat]="isAiChatRoute"
      [style.--bw-assistant-side-width]="assistantSideWidthCss"
      [style.--bw-assistant-bottom-height]="assistantBottomHeightCss"
    >
      <app-sidebar
        class="bw-app-shell__sidebar-host"
        [class.bw-app-shell__sidebar-host--hidden]="!desktopSidebarVisible && !isCompactMode"
        [collapsed]="isSidebarCollapsed"
        [hidden]="!desktopSidebarVisible"
        [pinnedExpanded]="desktopSidebarPinnedExpanded"
        [compact]="isCompactMode"
        [open]="mobileSidebarOpen"
        [userRole]="currentUser?.platformRole ?? null"
        (hoverExpandRequest)="expandSidebarOnHover()"
        (hoverCollapseRequest)="collapseSidebarAfterHover()"
        (closeRequest)="closeMobileSidebar()"
        (pinToggleRequest)="toggleSidebarPinMode()"
      ></app-sidebar>

      <main class="bw-app-shell__main">
        <div class="bw-app-shell__page" [class.bw-app-shell__page--full-width]="currentConfig.fullWidth">
          <router-outlet></router-outlet>
        </div>
      </main>

      @if (routeHasRightPanel) {
        <div
          class="bw-app-shell__right-panel-host"
          [class.bw-app-shell__right-panel-host--overlay]="isCompactMode"
        >
          <app-right-panel
            [config]="currentConfig.rightPanel ?? null"
            [compact]="isCompactMode"
            [open]="showRightPanel"
            (toggleRequest)="toggleRightPanel()"
            (closeRequest)="closeRightPanel()"
          ></app-right-panel>
        </div>
      }

      @if (!isAiChatRoute) {
        @if (assistantLayout.isOpen && assistantLayout.displayMode === 'side' && !isCompactMode) {
          <div
            class="bw-app-shell__assistant-resizer bw-app-shell__assistant-resizer--side"
            role="separator"
            tabindex="0"
            aria-label="Resize BizzWeaver AI side panel"
            aria-orientation="vertical"
            [attr.aria-valuemin]="352"
            [attr.aria-valuemax]="assistantSideWidthMaximum"
            [attr.aria-valuenow]="assistantLayout.sidePanelWidth"
            (pointerdown)="beginAssistantResize($event, 'side')"
            (keydown)="resizeAssistantWithKeyboard($event, 'side')"
          ></div>
        }
        @if (assistantLayout.isOpen && assistantLayout.displayMode === 'bottom' && !isCompactMode) {
          <div
            class="bw-app-shell__assistant-resizer bw-app-shell__assistant-resizer--bottom"
            role="separator"
            tabindex="0"
            aria-label="Resize BizzWeaver AI bottom panel"
            aria-orientation="horizontal"
            [attr.aria-valuemin]="240"
            [attr.aria-valuemax]="assistantBottomHeightMaximum"
            [attr.aria-valuenow]="assistantLayout.bottomPanelHeight"
            (pointerdown)="beginAssistantResize($event, 'bottom')"
            (keydown)="resizeAssistantWithKeyboard($event, 'bottom')"
          ></div>
        }
        <app-ai-assistant
          class="bw-app-shell__assistant-host"
          [class.bw-app-shell__assistant-host--side]="assistantLayout.isOpen && assistantLayout.displayMode === 'side' && !isCompactMode"
          [class.bw-app-shell__assistant-host--bottom]="assistantLayout.isOpen && assistantLayout.displayMode === 'bottom' && !isCompactMode"
          [class.bw-app-shell__assistant-host--floating]="!assistantLayout.isOpen || assistantLayout.displayMode === 'floating' || isCompactMode"
          [user]="currentUser"
        ></app-ai-assistant>
      }
    </div>
  </div>
}
<app-context-menu></app-context-menu>
